export default function componentStyles(palette) {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: palette.surface['7'],
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        textPrimary: {
          color: palette.borders.focus,
        },
        outlined: {
          borderColor: palette.borders.strong,
          borderWidth: '1px',
          borderStyle: 'solid',
        },
      },
      variants: [
        {
          props: { variant: 'tertiary' },
          style: {
            backgroundColor: 'red',
          },
        },
      ],
    },
    MuiPaper: {
      defaultProps: {
        square: true,
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: palette.surface['2'],
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        colorDefault: {
          backgroundColor: palette.surface['4'],
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        tabs: {
          backgroundColor: palette.surface['1'],
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& fieldset': {
            borderColor: palette.borders.strong,
          },
        },
        select: {
          padding: '8px 34px 8px 10px !important',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '&::-webkit-scrollbar': {
          width: '5px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: `rgba(255, 255, 255, 0.1)`,
          borderRadius: '10px',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          background: palette.surface['1'],
          color: palette.text.primary,
          borderColor: palette.borders.bold,
          borderWidth: '2px',
          borderStyle: 'solid',
          borderRadius: '0.5rem',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderColor: palette.borders.bold,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: palette.surface['5'],
          color: palette.text.secondary,
          height: '56px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: palette.borders.bold,
        },
        head: {
          color: palette.text.secondary,
          boxShadow: '16px 0px 3px -16px #B6C3CC',
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          color: palette.text.secondary,
          '&.Mui-active': {
            color: palette.text.secondary,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled .Mui-disabled': {
            WebkitTextFillColor: 'rgba(255, 255, 255, 0.8)',
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          borderColor: palette.borders.bold,
          border: 0,
          '.MuiDataGrid-overlayWrapper': {
            height: 'auto !important',
            marginTop: '50px',
            marginBottom: '50px',
          },
          '.MuiDataGrid-overlayWrapperInner': {
            height: 'auto !important',
          },
        },
        columnHeader: {
          backgroundColor: palette.surface['5'],
          color: palette.text.secondary,
        },
        columnSeparator: {
          color: palette.text.secondary,
        },
        cell: {
          borderColor: palette.borders.bold,
        },
      },
    },
  };
}
